"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActiveLine = void 0;
Object.defineProperty(exports, "CirculationChart", {
  enumerable: true,
  get: function get() {
    return _CirculationChart.default;
  }
});
Object.defineProperty(exports, "DeviceChart", {
  enumerable: true,
  get: function get() {
    return _DeviceChart.default;
  }
});
exports.getTimeFormatTitle = exports.getTimeFormat = exports.getTickValues = exports.getPositionForTitle = exports._lineTheme = exports.PredictionZone = exports.LineItem = exports.EmptyZoneMesh = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.reverse.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.array.reduce.js");
var _DeviceChart = _interopRequireDefault(require("./DeviceChart"));
var _CirculationChart = _interopRequireDefault(require("./CirculationChart"));
require("../../styles/components/Charts/\u0421harts.css");
var _moment = _interopRequireDefault(require("moment"));
var _react = _interopRequireWildcard(require("react"));
var _d3Shape = require("d3-shape");
var _core = require("@nivo/core");
var _web = require("@react-spring/web");
var _tooltip = require("@nivo/tooltip");
var _voronoi = require("@nivo/voronoi");
var _paulCorePackage = require("paul-core-package");
var _constants = require("../../utils/constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const _lineTheme = exports._lineTheme = {
  disabledLine: '#b4b4b459',
  background: 'transparent',
  textColor: '#8E8EA9',
  fontSize: 14,
  grid: {
    line: {
      stroke: '#DCDCE4',
      strokeWidth: 1
    }
  },
  crosshair: {
    line: {
      stroke: '#666687',
      strokeWidth: 1,
      strokeOpacity: 1,
      strokeDasharray: '1 0'
    }
  }
};
const ActiveLine = exports.ActiveLine = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
    activeLinePosition = {}
  } = _ref;
  const {
    x = 0,
    y = 0
  } = activeLinePosition;
  return /*#__PURE__*/_react.default.createElement("line", {
    x1: x,
    y1: 0,
    x2: x,
    y2: y,
    style: _lineTheme.crosshair.line,
    className: "show-line"
  });
});
const getPositionForTitle = (d, index) => {
  if (!d[index] || !d[index].data.length) return 0;
  let difference;
  const array = [];
  for (let i = 0; i < d.length; i++) {
    var _d$i$data;
    const {
      length
    } = d[index].data || [];
    const data = [...d[index].data];
    const iLastData = length - 1 - data.reverse().findIndex(v => v.y);
    array[i] = ((_d$i$data = d[i].data[iLastData >= length - 1 ? length - 1 : iLastData]) === null || _d$i$data === void 0 ? void 0 : _d$i$data.y) || 0;
  }
  const differenceRange = 8;
  for (let i = 0; i < array.length - 1; i++) {
    difference = Math.abs(array[i] - array[i + 1]);
    if (difference < differenceRange) {
      if (array[i] >= array[i + 1] && array[i] === array[index]) {
        array[i] += (differenceRange - difference) / 2;
      } else if (array[i] >= array[i + 1]) {
        array[i + 1] -= (differenceRange - difference) / 2;
      } else if (array[i] < array[i + 1] && array[i] === array[index]) {
        array[i] -= (differenceRange - difference) / 2;
      } else {
        array[i] += (differenceRange - difference) / 2;
      }
    }
  }
  return array[index];
};
exports.getPositionForTitle = getPositionForTitle;
const _getPredictionTextForSVG = (xScale, t) => /*#__PURE__*/_react.default.createElement("g", {
  transform: "translate(".concat(xScale((0, _moment.default)().add(2, 'days').hour(0)), ", -14)")
}, /*#__PURE__*/_react.default.createElement("g", {
  transform: "translate(82, -11)"
}, /*#__PURE__*/_react.default.createElement("svg", {
  width: "30",
  height: "12",
  viewBox: "0 0 30 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M29.2129 6.53033C29.5058 6.23744 29.5058 5.76256 29.2129 5.46967L24.44 0.696699C24.1471 0.403806 23.6722 0.403806 23.3793 0.696699C23.0864 0.989593 23.0864 1.46447 23.3793 1.75736L27.622 6L23.3793 10.2426C23.0864 10.5355 23.0864 11.0104 23.3793 11.3033C23.6722 11.5962 24.1471 11.5962 24.44 11.3033L29.2129 6.53033ZM0.682617 6.75H28.6826V5.25H0.682617V6.75Z",
  fill: "#1CE783"
}))), /*#__PURE__*/_react.default.createElement("text", {
  fill: '#00205B'
}, "Prediction"));
const PredictionZone = exports.PredictionZone = /*#__PURE__*/(0, _react.memo)(_ref2 => {
  var _series$;
  let {
    series,
    xScale,
    yScale,
    isPrediction = false,
    t,
    innerHeight
  } = _ref2;
  if (!series[0]) return null;
  const areaGenerator = (0, _d3Shape.area)().x(d => xScale(d.data.x) < xScale((0, _moment.default)().hour(0)) ? xScale((0, _moment.default)().hour(0)) : xScale(d.data.x) || 0).y0(() => 0).y1(() => innerHeight);
  return /*#__PURE__*/_react.default.createElement("g", {
    className: "".concat(!isPrediction ? 'opacity-0' : '', " def-opacity-0")
  }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "prediction_gradient"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "100%"
  }))), /*#__PURE__*/_react.default.createElement("path", {
    d: areaGenerator((_series$ = series[0]) === null || _series$ === void 0 ? void 0 : _series$.data),
    id: 'prediction_fill',
    fill: "cornflowerblue",
    opacity: 0.1
  }), _getPredictionTextForSVG(xScale, t));
}, _paulCorePackage.functions.areEqual);
const LineItem = exports.LineItem = /*#__PURE__*/(0, _react.memo)(_ref3 => {
  let {
    line,
    lineGenerator,
    xScale,
    yScale
  } = _ref3;
  const {
    id,
    data,
    color,
    strokeDasharray
  } = line;
  const path = lineGenerator(data.map(d => ({
    x: xScale(d.data.x ? new Date(d.data.x) : null),
    y: d.data.y ? yScale(d.data.y.toString()) : null
  })));
  const animatedPath = (0, _core.useAnimatedPath)(path);
  return /*#__PURE__*/_react.default.createElement(_web.animated.path, {
    key: id,
    d: animatedPath,
    fill: "none",
    stroke: color,
    style: {
      strokeDasharray: strokeDasharray || 0,
      strokeWidth: 1
    }
  });
}, _paulCorePackage.functions.areEqual);
const _MemoAreaLayerRedContent = _ref4 => {
  let {
    d,
    index,
    yMinValue,
    innerWidth
  } = _ref4;
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: "redArea".concat(index)
  }, /*#__PURE__*/_react.default.createElement(_core.Defs, {
    defs: [{
      id: "patternRed".concat(index),
      type: 'patternLines',
      background: '#D02B20',
      color: '#D02B20',
      pointerEvents: 'none'
    }]
  }), /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "cut-off-bottom".concat(index)
  }, /*#__PURE__*/_react.default.createElement("rect", {
    x: "0",
    y: "0",
    width: innerWidth,
    height: yMinValue < 0 ? 0 : yMinValue
  })), /*#__PURE__*/_react.default.createElement("path", {
    clipPath: "url(#cut-off-bottom".concat(index, ")"),
    d: d,
    fill: "url(#patternRed".concat(index, ")"),
    fillOpacity: 0.1
  })), [d, index, yMinValue, innerWidth]);
};
const _setDefaultActiveData = _ref5 => {
  var _series$2, _series$3;
  let {
    series,
    innerHeight
  } = _ref5;
  const lastIndexWithData = Math.abs(((_series$2 = series[0]) === null || _series$2 === void 0 ? void 0 : _series$2.data.length) - 1 - [...(((_series$3 = series[0]) === null || _series$3 === void 0 ? void 0 : _series$3.data) || [])].reverse().findIndex(d => {
    var _d$data;
    return (_d$data = d.data) === null || _d$data === void 0 ? void 0 : _d$data.x;
  }));
  return {
    slice: {
      height: innerHeight,
      points: series.map(s => {
        var _s$data$lastIndexWith;
        return {
          serieId: s.id,
          id: "".concat(s.id, ".").concat(lastIndexWithData),
          data: ((_s$data$lastIndexWith = s.data[lastIndexWithData]) === null || _s$data$lastIndexWith === void 0 ? void 0 : _s$data$lastIndexWith.data) || []
        };
      }),
      x: series[0].data[lastIndexWithData].position.x,
      y: 0
    }
  };
};

// const MemoAreaLayerRed = ({
//         series, xScale, yScale, rule, index, setXScale,
//         setYScale, activeLineIsNull = true, setActiveLine,
//         innerHeight, propertyId, innerWidth
//     }) => useMemo(() => {
//         if (!series[index] || !rule) return null;
//         if (activeLineIsNull) {
//             setActiveLine(_setDefaultActiveData({ series, innerHeight }));
//         }
//         setXScale(xScale)
//         setYScale(yScale)
//         if (disabledRedZone[propertyId] && disabledRedZone[propertyId].includes(parseInt(series[index]?.id))) {
//              return null;
//         }
//         const minValue = rule.max || 100
//         const yMinValue = yScale(minValue) > innerHeight ? innerHeight : yScale(minValue);
//         const areaGenerator = area()
//             .x(d => xScale(d.data.x))
//             .y0(d => yScale(d.data.y || minValue))
//             .y1(d => d.data.y >= minValue
//                 ? yMinValue + 50 // 50 to remove the rounding of the bottom line
//                 : yScale(!!d.data.y
//                     ? d.data.y
//                     : minValue))
//             .curve(curveCatmullRom);
//         const d = areaGenerator(series[index]?.data)
//         return <_MemoAreaLayerRedContent d={d} yMinValue={yMinValue} index={index} innerWidth={innerWidth} />
//     }, [series, xScale, yScale, rule, index, setXScale, setYScale, activeLineIsNull, setActiveLine, innerHeight, innerWidth]);

const EmptyTooltip = text => /*#__PURE__*/_react.default.createElement("div", {
  className: "flex-column line-chart-tooltip-value"
}, /*#__PURE__*/_react.default.createElement("span", null, text));
const EmptyZoneMesh = layerData => {
  const {
    showTooltipAt,
    hideTooltip
  } = (0, _tooltip.useTooltip)();
  const handleMouseEnter = point => {
    showTooltipAt(
    // layerData.tooltip({ point }),
    EmptyTooltip('No Data'), [point.x + layerData.margin.left, point.y + layerData.margin.top], 'top');
  };
  const handleMouseMove = point => {
    showTooltipAt(EmptyTooltip('No Data'), [point.x + layerData.margin.left, point.y + layerData.margin.top], 'top');
  };
  const nullValuePoints = layerData.series.reduce((acc, cur) => {
    cur.data.forEach(_ref6 => {
      let {
        data,
        position
      } = _ref6;
      if (data.y === null) {
        const point = {
          x: position.x,
          y: 100,
          //whatever you want
          data: {
            x: data.x
          }
        };
        acc.push(point);
      }
    });
    return acc;
  }, []);
  return /*#__PURE__*/_react.default.createElement(_voronoi.Mesh, {
    nodes: [...layerData.points, ...nullValuePoints],
    width: layerData.innerWidth,
    height: layerData.innerHeight,
    onMouseEnter: handleMouseEnter,
    onMouseMove: handleMouseMove,
    onMouseLeave: hideTooltip,
    debug: layerData.debugMesh
  });
};
exports.EmptyZoneMesh = EmptyZoneMesh;
const getTimeFormatTitle = (tick, rangeType, dateType) => {
  const isFirstDayOfMonth = (0, _moment.default)(tick).date() === 1;
  const isFirstHourOfDay = !(0, _moment.default)(tick).hour();
  const isFirstMonthInYear = !(0, _moment.default)(tick).month();
  const isStartOfMonth = isFirstDayOfMonth && isFirstHourOfDay;
  const showOnEveryDay = dateType === _constants.constDateType.hour || dateType === _constants.constDateType.day;
  if (showOnEveryDay ? !isFirstHourOfDay : !isFirstDayOfMonth) {
    return '';
  }
  const showDateByCondition = _ref7 => {
    let {
      condition,
      format = 'MMM DD'
    } = _ref7;
    return condition ? (0, _moment.default)(tick).format(format) : '';
  };
  switch (dateType) {
    case _constants.constDateType.hour:
      return showDateByCondition({
        condition: isFirstHourOfDay
      });
    case _constants.constDateType.day:
      return showDateByCondition({
        condition: isFirstHourOfDay
      });
    case _constants.constDateType.week:
      return showDateByCondition({
        condition: isStartOfMonth
      });
    case _constants.constDateType.month:
      return showDateByCondition({
        condition: isFirstHourOfDay,
        format: 'MMM'
      });
    case _constants.constDateType.year:
    case _constants.constDateType.max:
      return showDateByCondition({
        condition: isFirstMonthInYear,
        format: 'YYYY'
      });
    default:
      return '';
  }
};
exports.getTimeFormatTitle = getTimeFormatTitle;
const getTimeFormat = (tick, rangeType, dateType) => {
  const isFirstHourOfDay = !(0, _moment.default)(tick).hour();
  switch (dateType) {
    case _constants.constDateType.hour:
    case _constants.constDateType.day:
      return (0, _moment.default)(tick).format('HH:mm');
    case _constants.constDateType.week:
      return isFirstHourOfDay ? (0, _moment.default)(tick).format('dd') : '';
    case _constants.constDateType.month:
      return (0, _moment.default)(tick).format('DD');
    case _constants.constDateType.year:
    case _constants.constDateType.max:
      return (0, _moment.default)(tick).format('MMM');
    default:
      return '';
  }
};
exports.getTimeFormat = getTimeFormat;
const getTickValues = _ref8 => {
  let {
    dateType
  } = _ref8;
  switch (dateType) {
    case _constants.constDateType.month:
      return "every ".concat(window.innerWidth < 1300 ? 2 : 1, " days");
    case _constants.constDateType.year:
    case _constants.constDateType.max:
      return "every 1 month";
    default:
      return undefined;
  }
};
exports.getTickValues = getTickValues;